import React, { Component } from 'react'
import LoginHeader from "../LoginHeader";
import LoginLeftCont from "../LoginLeftCont";
import LoginRightCont from "../LoginRightCont";
import textModeBg from './images/img_bg_login@2x.png';
import imageModeBg from './images/img_tongyong@2x.png';
import centerModeBg from './images/img_bg_center_login@2x.png';
import gonganbeian from './images/gonganbeian.png';
import './index.css'
import { setPageTitle } from '../../utils/setPageTitle';

export default class Login extends Component {
    state = window.data_config ? {
        ...window.data_config,
        remberPassword: true,
        remberPasswordShow: true,
        siteName: window.title,
        corpLogoImageUrl: `${window.media_domain}/logo.png`,
        corpLogoSwitch: true,
        language: true,
        register: true,
        hasAccountLogin: true,
        hasSSOLogin: true
    } : {
        remberPassword: true,
        remberPasswordShow: true,
        siteName: window.title,
        corpLogoImageUrl: `${window.media_domain}/logo.png`,
        corpLogoSwitch: true,
        language: true,
        register: true,
        hasAccountLogin: true,
        hasSSOLogin: true
    }

    constructor(props) {
        super(props);
        const {customLogin} = window.data_config;
        if(customLogin){
            const {autoClose, corpLogoImageUrl, corpLogoSwitch, language, mode, register, showFigure, showFigureImageUrl, siteName} = customLogin.customLoginConfig;
            this.state.login_css_mode = showFigure ? 3 : 1;
            this.state.login_img_url = showFigureImageUrl;
            this.state.remberPassword = autoClose === "checked" ? true : autoClose === "unchecked" ? false : false;
            this.state.remberPasswordShow = autoClose !== "hide";
            this.state.siteName = siteName;
            this.state.corpLogoImageUrl = corpLogoImageUrl;
            this.state.corpLogoSwitch = corpLogoSwitch;
            this.state.language = language;
            this.state.register = register;
            this.state.hasAccountLogin = mode.indexOf("account") > -1;
            this.state.hasSSOLogin = mode.indexOf("sso") > -1;
        }
        
        this.footer = React.createRef();
        this.mirror = React.createRef();
    }

    componentDidMount() {
        const _this = this;
        this.screenHeight = window.innerHeight;
        setTimeout(() => {
            _this.setState({ loading: true })
        }, 30)
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        this.setState({
            ISMobileEmpty: !!this.getContNumV.state.pageSwitch.ISMobileEmpty,
            isMirror: React.cookie.load("bby_mirror_access"),
            mirrorTime: React.cookie.load("bby_mirror_access"),
            isAndroid:isAndroid
        })

        setPageTitle(React.language("user.login") + " - " + window._bby_config.site_name);
        this.cleanEntryCacheUserid();
        window.addEventListener("resize", this.watchResize);

        if ('BroadcastChannel' in window) {
            // 创建一个 BroadcastChannel 实例
            const channel = new BroadcastChannel('myChannel');
          
            // 监听消息事件
            channel.addEventListener("message", (event) => {
                console.log(event.data); // 输出接收到的消息
                const customLoginConfig = event.data ? event.data.customLoginConfig : {};
                const {autoClose, corpLogoImageUrl, corpLogoSwitch, language, mode, register, showFigure, showFigureImageUrl, siteName} = customLoginConfig;
    
                _this.setState({
                    login_css_mode: showFigure ? 3 : 1,
                    login_img_url: showFigureImageUrl,
                    remberPassword: autoClose === "checked" ? true : autoClose === "unchecked" ? false : false,
                    remberPasswordShow: autoClose === "hide" ? false : true,
                    siteName: siteName,
                    corpLogoImageUrl: corpLogoImageUrl,
                    corpLogoSwitch: corpLogoSwitch,
                    language: language,
                    register: register,
                    hasAccountLogin: mode.indexOf("account") > -1,
                    hasSSOLogin: mode.indexOf("sso") > -1,
                })
            });
          
            // 发送消息
        } else {
        console.log('当前浏览器不支持 BroadcastChannel。');
        }
    }

    componentWillUnmount = () =>{
        window.removeEventListener("resize", this.watchResize);
    }

    watchResize = () =>{
        let newHeight = window.innerHeight;
        if(newHeight < this.screenHeight){
            if(this.footer.current){
                this.footer.current.style.display = "none";
            }
            if(this.mirror.current){
                this.mirror.current.style.display = "none";
            }
		}else {
			if(this.footer.current){
                this.footer.current.style.display = "flex";
            }
            if(this.mirror.current){
                this.mirror.current.style.display = "flex";
            }
		}
    }

    //清理用户的登陆状态
    cleanEntryCacheUserid = () => {

        // let contText = BsyUtils.Store.get(key) || {};
        // contText[window.FX.STATIC.corpId] = {
        //     ...contText[window.FX.STATIC.corpId],
        //     selectAppid: null,
        //     user_id:window.FX.STATIC["user"]._id
        // };
        // BsyUtils.Store.set(key, contText);

        for (var i = 0; i < localStorage.length; i++) {
            var key = localStorage.key(i); //获取本地存储的Key
            if (key.indexOf('_appID_') > -1) {
                let dd = localStorage.getItem(key)
                if (dd) {
                    let ds = JSON.parse(dd);
                    for (const key in ds) {
                        if (ds[key]) {
                            ds[key].user_id = null;
                        }
                    }
                    localStorage.setItem(key, JSON.stringify(ds))
                }
            }
        }
    }


    getContNum = (ref) => {
        this.getContNumV = ref
    }

    changeMirror = (ref) => {
        React.axios('/user/mirror_access', {}).then((res) => {
            window.FX.UI.closePopover()
            this.setState({ isMirror: true, mirrorTime: res.data.time })
        }).catch(() => {

        })
    }

    quitMirror = () => {
        React.axios('/user/mirror_quit', {}).then((res) => {
            window.FX.UI.closePopover()
            this.setState({ isMirror: false },()=>{
                window.FX.Cookie.remove("bby_mirror_access", { path: '/' })
                window.FX.Cookie.remove("mirrorIsOnce",{path:'/'});
            })
        }).catch(() => {

        })
    }

    render() {
        let { hasSSOLogin, hasAccountLogin, register, language, corpLogoSwitch, corpLogoImageUrl, siteName, remberPasswordShow, remberPassword, leftDes1, leftDes2, leftTitle, loading, rightTitle, defaultLogin, isMirror, mirrorTime, isAndroid, login_css_mode, login_img_url } = this.state;
        let customLoginConfig = {
            hasSSOLogin, hasAccountLogin, register, language, corpLogoSwitch, corpLogoImageUrl, siteName, remberPasswordShow, remberPassword
        }
        let mirror_access_time = window.data_config.mirror_access_time
        let timeCookie = Number(mirror_access_time) * 1000;
        let year = new Date(timeCookie).getFullYear();
        let month = new Date(timeCookie).getMonth() + 1;
        let centerSwitch = login_css_mode === 1;
        let textSwitch = login_css_mode === 2;
        let imageSwitch = login_css_mode === 3;
        if(month<=9){
            month = "0" + month;
        }
        let day = new Date(timeCookie).getDate();
        if(day<=9){
            day = "0" + day;
        }
        let isMirrorCss = {};
        let footerCss = {};
        let loginContBgCss = {};
        let loginBannerBgCss = {};
        if(centerSwitch){
            loginContBgCss.backgroundImage = `url(${centerModeBg})`;
        }else if(imageSwitch){
            loginBannerBgCss.backgroundImage = `url(${login_img_url || imageModeBg})`;
        }else if(textSwitch){
            loginContBgCss.backgroundImage = `url(${textModeBg})`;
        }

        if(isMirror){
            loginContBgCss.backgroundImage = `url(${centerModeBg})`;
        }
        

        if(window.screen.width<=1200 && isAndroid){
            isMirrorCss.top = '100%';
            isMirrorCss.transform = 'translate(-50%, calc(-100% - 48px))';
            footerCss.top = '100%';
            footerCss.transform = 'translate(0, -100%)';
        }
        let time = React.language('date.year_month_day',{year,month,day});
        return (
            <div className={"login "+ (isAndroid ? "isAndroid" : "")} style={{ 'display': loading ? "block" : "none" }} key={new Date().getTime()}>
                <div className={`loginCont ${centerSwitch ? 'isCenterMode' : ''}`} style={loginContBgCss}>
                    <div className={`content ${(!isMirror && imageSwitch) ? 'isImageMode' : ''}`}>
                        <div className={`left-box ${isMirror ? 'isMirror' : ''} ${(!isMirror && imageSwitch) ? 'isImageMode' : ''}`}>
                            {(window.screen.width > 1200 || (window.data_config.commonLogin || (window.data_config.mobileCodeLogin || window.data_config.emailCodeLogin))) && <LoginHeader customLoginConfig={customLoginConfig} isMirror={isMirror} mirrorTime={mirrorTime} />}
                            <div className={`box`}>
                                <div className="cont">
                                    <LoginRightCont customLoginConfig={customLoginConfig} isMirror={isMirror} headerShow={this.getContNum} rightTitle={rightTitle} defaultLogin={defaultLogin} />
                                </div>
                                {window.data_config.mirror_access ? (!isMirror ? <div className="mirror" ref={this.mirror} style={isMirrorCss} onClick={this.changeMirror}>
                                    <span>{React.language('login.mirror.access')}</span>
                                    {window.screen.width > 1200 && <i className="icon-dingding-sso-help" onMouseEnter={(event) => {
                                        window.FX.UI.showPopover({
                                            position: "top",
                                            anchor: window.$(event.target),
                                            content: window.$("<span/>").text(React.language('login.mirror.access.msg1')),
                                            type: "dark"
                                        })
                                    }} onMouseLeave={() => {
                                        window.FX.UI.closePopover()
                                    }} />}
                                </div> : <div style={isMirrorCss} className="quitMirror" onClick={this.quitMirror}>
                                    <i className="icon-bsy-quit-mirror" />
                                    <span>{React.language('login.mirror.access.quit')}</span>
                                </div>) : <></>}
                            </div>
                        </div>
                        <div className="right-box">
                            {(!isMirror && imageSwitch) && <div className="banner-bg" style={loginBannerBgCss}></div>}
                            {(!isMirror && textSwitch) && <LoginLeftCont leftTitle={leftTitle} leftDes1={leftDes1} leftDes2={leftDes2} />}
                        </div>
                    </div>
                </div>
                {(window.location.pathname.indexOf("/corp/url") < 0 && window.location.pathname.indexOf("/corp/login_setting") < 0) && <div className={`footer ${(!isMirror && imageSwitch) ? 'isImageMode' : ''}`} ref={this.footer} style={footerCss}>
                    <div className="record_number">
                        <a target="_blank" rel="noreferrer" href="http://beian.miit.gov.cn">{window.sitesetting.before_record_number + " " + window.sitesetting.after_record_number}</a>
                    </div>
                    {!!window.sitesetting.gongan_record_number && <div className="record_number">
                        <a target="_blank" rel="noreferrer" href={`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${window.sitesetting.gongan_record_number.replace(/[^\d]/g,'')}`}>
                            <img src={gonganbeian} alt="" />
                            <span>{window.sitesetting.gongan_record_number}</span>
                        </a>
                    </div>}
                </div>}
            </div>
        )
    }
}